import { Command } from 'cmdk';
import { useRef, useState } from 'react';
import { Button } from '@jjj/components';
import CloseIcon from '@mui/icons-material/Close';
import { t } from 'src/i18n';
import SearchIcon from '../../../assets/svg/icon-search.svg';
import { ClearButton, SearchInput } from './globalSearchInput.style';

const GlobalSearchInput = ({ onValueChange, org, lastQuery, onClear }) => {
  const [query, setQuery] = useState('');
  const inputRef = useRef(null);

  const clearInput = () => {
    setQuery('');
    onClear();

    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <SearchInput>
      <img alt="" src={SearchIcon} className="search-input-icon" />
      <Command.Input
        autoFocus
        ref={inputRef}
        placeholder={t('dash.globalSearch.search_placeholder', { org })}
        className="search-input-field"
        onValueChange={event => {
          onValueChange(event);
          setQuery(event);
        }}
        value={query}
      />
      {lastQuery && (
        <ClearButton className="global-search-clear-button">
          <Button type="link" className="global-search-clear-button" onClick={clearInput}>
            <CloseIcon />
          </Button>
        </ClearButton>
      )}
    </SearchInput>
  );
};

export default GlobalSearchInput;
